
import Highcharts from 'highcharts';
import PieChart from "highcharts-react-official";

export default function Pie({
  series,
  title
}: {
    series: any,
    title:string
}) {

  (function (H : any) {
    H.seriesTypes.pie.prototype.animate = function (init:any) {
        const series = this,
            chart = series.chart,
            points = series.points,
            {
                animation
            } = series.options,
            {
                startAngleRad
            } = series;

        function fanAnimate(point:any, startAngleRad:any) {
            if(point){
                const graphic = point.graphic,
                    args = point.shapeArgs;

                if (graphic && args) {

                    graphic
                        // Set inital animation values
                        .attr({
                            start: startAngleRad,
                            end: startAngleRad,
                            opacity: 1
                        })
                        // Animate to the final position
                        .animate({
                            start: args.start,
                            end: args.end
                        }, {
                            duration: animation.duration / points.length
                        }, function () {
                            // On complete, start animating the next point
                            if (points[point.index + 1]) {
                                fanAnimate(points[point.index + 1], args.end);
                            }
                            // On the last point, fade in the data labels, then
                            // apply the inner size
                            if (point.index === series.points.length - 1) {
                                series.dataLabelsGroup.animate({
                                    opacity: 1
                                },
                                void 0,
                                function () {
                                    points.forEach((point:any) => {
                                        point.opacity = 1;
                                    });
                                    series.update({
                                        enableMouseTracking: true
                                    }, false);
                                    chart.update({
                                        plotOptions: {
                                            pie: {
                                                innerSize: '0%',
                                                borderRadius: 8
                                            }
                                        }
                                    });
                                });
                            }
                        });
                }
            }
        }

        if (init) {
            // Hide points on init
            points.forEach((point:any) => {
                point.opacity = 0;
            });
        } else {
            fanAnimate(points[0], startAngleRad);
        }
    };
}(Highcharts));
 
  const options = {
    chart: {
      type: "pie"
    },
    title: {
      text: title
    },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b>'
    },
    credits: {
      enabled: false
    },
    series: [
        {
          data: series
        }
    ]
  };
  
  return (
    <PieChart highcharts={Highcharts} options={options} />
  )
}
